import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./personHome.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./personHome.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/views/personHome/personHome.vue?vue&type=script&lang=js&
// module id = bzNP
// module chunks = 0